// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PartnerScoreV2CssHelper from "../../../domain/helper/PartnerScoreV2CssHelper.bs.js";

function SliderTrackSpanCmp(Props) {
  var current_score = Props.current_score;
  var max_score = Props.max_score;
  var index = Props.index;
  return React.createElement("div", {
              className: "slider-track-span",
              style: {
                background: PartnerScoreV2CssHelper.getSliderTrackBackgroundColor(current_score, max_score, index)
              }
            });
}

var make = SliderTrackSpanCmp;

export {
  make ,
  
}
/* react Not a pure module */
